import { useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import './App.scss'
import {
	AdminAuth,
	DashboardPage,
	FeedbackList,
	NotificationList,
	NotificationSend,
	LoginPage,
	ReportList,
	UserList,
	ChatEngagement,
	UserManagement,
	WordList,
	WordTypes,
	OrderList,
	AnnouncementList,
	AnnouncementCreate,
	ReleaseList,
	ReleaseCreate,
	EmailContentList,
	EmailContentCreate,
	EmailSend,
	EmailSendHistory,
	EmailSendJobDetail,
	BlogList,
	BlogCreate,
	AgentsProductOwner,
	AgentsContentMarketing,
	AgentsEngineer,
	AgentsProjectManager,
	AgentsConfigs,
	CategoryNewList,
	CategoryIntroList,
	I18nLanguageList,
	I18nTranslationEditor,
	I18nCourseTranslations,
	VoucherList,
} from './containers'
import { DictList } from './containers/DictList/DictList'
import { AdminContext } from './context/admin.context'
import { ROUTE } from './utils/constant'

function App() {
	const [adminContext, setAdminContext] = useState('')

	return (
		<div className="app">
			<AdminContext.Provider value={[adminContext, setAdminContext]}>
				<Switch>
					<Route exact path={ROUTE.LOGIN} component={LoginPage} />
					<AdminAuth>
						{/* Route for dashboard */}
						<Route
							exact
							path={ROUTE.DASHBOARD}
							component={DashboardPage}
						/>
						{/* Routes for user management */}
						<Route
							exact
							path={`${ROUTE.USER_MANAGEMENT}${ROUTE.USER_MANAGEMENT}`}
							component={UserManagement}
						/>
						<Route
							exact
							path={`${ROUTE.USER_MANAGEMENT}${ROUTE.LIST}`}
							component={UserList}
						/>
						<Route
							exact
							path={`${ROUTE.USER_MANAGEMENT}${ROUTE.CHAT_ENGAGEMENT}`}
							component={ChatEngagement}
						/>
						{/* Routes for word management */}
						<Route
							exact
							path={`${ROUTE.WORD_MANAGEMENT}${ROUTE.LIST}`}
							component={WordList}
						/>
						{/* Routes for feedback management */}
						<Route
							exact
							path={`${ROUTE.FEEDBACK_MANAGEMENT}${ROUTE.LIST}`}
							component={FeedbackList}
						/>
						<Route
							exact
							path={`${ROUTE.FEEDBACK_MANAGEMENT}${ROUTE.REPORT}`}
							component={ReportList}
						/>
						{/* Routes for notification management */}
						<Route
							exact
							path={`${ROUTE.EMAIL_CONTENT_MANAGEMENT}${ROUTE.LIST}`}
							component={EmailContentList}
						/>
						<Route
							exact
							path={`${ROUTE.EMAIL_CONTENT_MANAGEMENT}${ROUTE.CREATE}`}
							component={EmailContentCreate}
						/>
						<Route
							exact
							path={`${ROUTE.EMAIL_CONTENT_MANAGEMENT}${ROUTE.EMAIL_SEND}`}
							component={EmailSend}
						/>
						<Route
							exact
							path={`${ROUTE.EMAIL_CONTENT_MANAGEMENT}${ROUTE.EMAIL_SEND_HISTORY}`}
							component={EmailSendHistory}
						/>
						<Route
							exact
							path={`${ROUTE.EMAIL_CONTENT_MANAGEMENT}${ROUTE.EMAIL_SEND_HISTORY}/:jobId`}
							component={EmailSendJobDetail}
						/>
						<Route
							exact
							path={`${ROUTE.BLOG_MANAGEMENT}${ROUTE.LIST}`}
							component={BlogList}
						/>
						<Route
							exact
							path={`${ROUTE.BLOG_MANAGEMENT}${ROUTE.CREATE}`}
							component={BlogCreate}
						/>
						<Route
							exact
							path={`${ROUTE.AGENTS_MANAGEMENT}${ROUTE.PRODUCT_OWNER}`}
							component={AgentsProductOwner}
						/>
						<Route
							exact
							path={`${ROUTE.AGENTS_MANAGEMENT}${ROUTE.CONTENT_MARKETING}`}
							component={AgentsContentMarketing}
						/>
						<Route
							exact
							path={`${ROUTE.AGENTS_MANAGEMENT}${ROUTE.ENGINEER}`}
							component={AgentsEngineer}
						/>
						<Route
							exact
							path={`${ROUTE.AGENTS_MANAGEMENT}${ROUTE.PROJECT_MANAGER}`}
							component={AgentsProjectManager}
						/>
						<Route
							exact
							path={`${ROUTE.AGENTS_MANAGEMENT}${ROUTE.AGENT_CONFIGS}`}
							component={AgentsConfigs}
						/>
						<Route
							exact
							path={`${ROUTE.RELEASE_MANAGEMENT}${ROUTE.LIST}`}
							component={ReleaseList}
						/>
						<Route
							exact
							path={`${ROUTE.RELEASE_MANAGEMENT}${ROUTE.CREATE}`}
							component={ReleaseCreate}
						/>
						<Route
							exact
							path={`${ROUTE.NOTIFICATION_MANAGEMENT}${ROUTE.LIST}`}
							component={NotificationList}
						/>
						<Route
							exact
							path={`${ROUTE.NOTIFICATION_MANAGEMENT}${ROUTE.NOTIFICATION_SEND}`}
							component={NotificationSend}
						/>
						{/* Product announcements (replaces Banner Management stub) */}
						<Route
							exact
							path={`${ROUTE.ANNOUNCEMENT_MANAGEMENT}${ROUTE.LIST}`}
							component={AnnouncementList}
						/>
						<Route
							exact
							path={`${ROUTE.ANNOUNCEMENT_MANAGEMENT}${ROUTE.CREATE}`}
							component={AnnouncementCreate}
						/>
						{/* Routes for order management */}

						<Route
							exact
							path={`${ROUTE.ORDER_MANAGEMENT}${ROUTE.LIST}`}
							component={OrderList}
						/>

						<Route
							exact
							path={`${ROUTE.DICTIONARY_MANAGEMENT}${ROUTE.LIST}`}
							component={DictList}
						/>
						<Route
							exact
							path={`${ROUTE.DICTIONARY_MANAGEMENT}${ROUTE.WORD_TYPES}`}
							component={WordTypes}
						/>
						{/* Course category New badge (mock UI — backend next) */}
						<Route
							exact
							path={`${ROUTE.COURSE_MANAGEMENT}${ROUTE.CATEGORY_NEW}`}
							component={CategoryNewList}
						/>
						<Route
							exact
							path={`${ROUTE.COURSE_MANAGEMENT}${ROUTE.CATEGORY_INTRO}`}
							component={CategoryIntroList}
						/>
						{/* i18n CMS routes */}
						<Route
							exact
							path={`${ROUTE.I18N_MANAGEMENT}${ROUTE.I18N_LANGUAGES}`}
							component={I18nLanguageList}
						/>
						<Route
							exact
							path={`${ROUTE.I18N_MANAGEMENT}${ROUTE.I18N_TRANSLATIONS}/:code`}
							component={I18nTranslationEditor}
						/>
						<Route
							exact
							path={`${ROUTE.I18N_MANAGEMENT}${ROUTE.I18N_COURSES}`}
							component={I18nCourseTranslations}
						/>
						<Route
							exact
							path={`${ROUTE.VOUCHER_MANAGEMENT}${ROUTE.LIST}`}
							component={VoucherList}
						/>
					</AdminAuth>
				</Switch>
			</AdminContext.Provider>
		</div>
	)
}

export default App
